import {
  Board,
  Shipment,
  ShippingAddress,
} from "../../../../reducers/uploadedBoard";
import { ShipmentsColumnContainer } from "./ShipmentsStyles";
import AddressInfo from "../../../addresses/AddressInfo";
import useGetShippingRates from "../../../../utils/hooks/shippingRates";
import { useBoardFromContext } from "../../../../utils/hooks/commonly-stored/uploaded-board/board";
import ShippingRateOption from "../../../ShoppingCartOrder/shipping/ShippingRateOption";
import FlashPCBSelect from "../../../common/FlashPCBSelect";
import Button from "../../../common/Button";
import React, { ReactNode, useEffect, useState } from "react";
import { ShippingRate } from "../../../../reducers/shoppingCartOrder";
import { SingleValue } from "react-select";
import { useUpdateShipments } from "../../../../utils/hooks/commonly-stored/uploaded-board/updates/shipments";
import LoadingOverlay from "../../../LoadingOverlay";
import { AlertText } from "../../../ShoppingCartOrder/shipping/SelectShippingRates/SelectShippingRatesStyles";

export default function PurchaseShippingLabel({
  shipment,
  onPurchase,
}: {
  shipment: Shipment;
  onPurchase: () => void;
}) {
  const board = useBoardFromContext().board as Board;
  const [selectedShippingRate, setSelectedShippingRate] =
    useState<ShippingRate | null>(null);
  const { shippingRates, shippingRateRestrictedToGround } = useGetShippingRates(
    shipment.id,
    shipment.delivery_info.order_owner_id as string,
    shipment.delivery_info.shipping_address as ShippingAddress,
    (board.quote.total_per_board as number) * shipment.num_boards,
    board.quote.currency,
    true,
  );
  const { purchaseShippingLabel, purchasingShippingLabel } =
    useUpdateShipments();

  useEffect(() => {
    if (shippingRates !== null) {
      const matchingRate = shippingRates.find(
        (rate) =>
          rate.service_level_name ==
          shipment.delivery_info.shipping_rate_specified_in_order
            ?.service_level_name,
      );
      if (matchingRate !== undefined) {
        setSelectedShippingRate(matchingRate);
      }
    }
  }, [
    shipment.delivery_info.shipping_rate_specified_in_order?.service_level_name,
    shippingRates,
  ]);

  const onChangeShippingRate = (
    newValue: SingleValue<{ value: ShippingRate; label: ReactNode }> | null,
  ) => {
    if (newValue !== null) {
      setSelectedShippingRate(newValue.value);
    } else {
      setSelectedShippingRate(null);
    }
  };

  const handlePurchase = () => {
    if (selectedShippingRate !== null) {
      purchaseShippingLabel(
        shipment.id,
        selectedShippingRate.shippo_rate_object_id,
        onPurchase,
      );
    }
  };

  return (
    <>
      <LoadingOverlay
        loading={purchasingShippingLabel}
        text={"Purchasing label..."}
      />
      <ShipmentsColumnContainer>
        <AddressInfo
          address={shipment.delivery_info.shipping_address as ShippingAddress}
        />
        <FlashPCBSelect
          isLoading={shippingRates === null}
          value={
            selectedShippingRate
              ? {
                  value: selectedShippingRate,
                  label: (
                    <ShippingRateOption shippingRate={selectedShippingRate} />
                  ),
                }
              : undefined
          }
          onChange={onChangeShippingRate}
          options={shippingRates?.map((rate) => {
            return {
              value: rate,
              label: <ShippingRateOption shippingRate={rate} />,
            };
          })}
        />

        <div>
          <Button
            disabled={selectedShippingRate === null}
            label={"Purchase"}
            onClick={handlePurchase}
          />
        </div>
      </ShipmentsColumnContainer>
      {shippingRateRestrictedToGround && (
        <AlertText>
          Shipping rates are restricted to ground due to lithium parts on the
          board.
        </AlertText>
      )}
    </>
  );
}
